import {
    Button,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
    Icon,
} from "@/shared/components";
import { cn } from "@/shared/utils";
import { Column, RowData } from "@tanstack/react-table";
import type { DataTableFeatures } from "./data-table-features";

type DataTableColumnHeaderProps<TData extends RowData, TValue> = {
    column: Column<DataTableFeatures, TData, TValue>;
    title: string;
    className?: string;
};

export function DataTableColumnHeader<TData extends RowData, TValue>({
    column,
    title,
    className,
}: DataTableColumnHeaderProps<TData, TValue>) {
    if (!column.getCanSort()) {
        return <div className={cn("text-content-emphasis", className)}>{title}</div>;
    }

    return (
        <div className={cn("flex items-center space-x-2", className)}>
            <DropdownMenu>
                <DropdownMenuTrigger asChild data-testid="table-column-header">
                    <Button variant="tertiary" size="s" className="data-[state=open]:bg-accent text-content-emphasis -ml-3 h-8">
                        <span>{title}</span>
                        {column.getIsSorted() === "desc" ? (
                            <Icon name="sort-down" className="ml-2" size="xs" />
                        ) : column.getIsSorted() === "asc" ? (
                            <Icon name="sort-up" className="ml-2" size="xs" />
                        ) : (
                            <Icon name="sort" className="ml-2" size="xs" />
                        )}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" data-testid="table-column-header">
                    <DropdownMenuItem onClick={() => column.toggleSorting(false)}>
                        <Icon name="sort-up" className="text-muted/70 mr-2 h-3.5 w-3.5" size="xs" />
                        Oplopend
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => column.toggleSorting(true)}>
                        <Icon name="sort-down" className="text-muted/70 mr-2 h-3.5 w-3.5" size="xs" />
                        Aflopend
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem onClick={() => column.toggleVisibility(false)}>
                        <Icon name="eye-conflict" className="text-muted/70 mr-2 h-3.5 w-3.5" size="xs" />
                        Verbergen
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
